import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { ManufacturerService } from '../../Services/Manufacturer/manufacturer.service';
import { Injectable } from '@angular/core';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GetAllManufacturers, EManufacturerActions, GetAddManufacturerSuccess, GetAllManufacturersSuccess, GetAllManufacturersError, AddManufacturer, GetAddManufacturerError, EditManufacturer, GetEditManufacturerSuccess, GetEditManufacturerError, GetManufacturerBystatusId } from '../actions/manufacturer.action';


@Injectable()
export class ManufacturerEffects {

    getallManufacturers$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllManufacturers>(EManufacturerActions.GetAllManufacturers),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.manufacturerService.getAllManufacturer(payload).pipe(
                map((result: any) => {
                    return new GetAllManufacturersSuccess(result);
                }),
                catchError((err) => of(new GetAllManufacturersError(err)))
            );
        })));

    addManufacturers$ = createEffect(() => this.actions$.pipe(
        ofType<AddManufacturer>(EManufacturerActions.AddManufacturer),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.manufacturerService.addManufacturer(payload).pipe(
                map((result: any) => {
                    return new GetAddManufacturerSuccess(result);
                }),
                catchError((err) => of(new GetAddManufacturerError(err)))
            );
        })));

    editManufacturers$ = createEffect(() => this.actions$.pipe(
        ofType<EditManufacturer>(EManufacturerActions.EditManufacturer),
        map(action => action.payload),
        switchMap((payload : any, param : any) => {
            return this.manufacturerService.editManufacturer(payload, param).pipe(
                map((result: any) => {
                    return new GetEditManufacturerSuccess(result);
                }),
                catchError((err) => of(new GetEditManufacturerError(err)))
            );
        })));

        getManufacturerByStatusId$ = createEffect(() => this.actions$.pipe(
            ofType<GetManufacturerBystatusId>(EManufacturerActions.GetManufacturerBystatusId),
            map(action => action.payload),
            mergeMap((action) => this.manufacturerService.getManufacturerByStatusId(action)
            .pipe(map((result: any) => ({ type: '[Manufacturers] Get Manufacturers By Status Id Success', payload: result, from: 'getManufacturerBystatusId' })),
              catchError((err) => of({ type: '[] Get Manufacturers By Status Id Error', payload:err, from: 'getManufacturerBystatusId' }))
            )
          )
        ));
        constructor(
            private actions$: Actions,
            private store: Store<IAppState>,
            private manufacturerService: ManufacturerService,

        ) { }

    }
